// 1. Combined all react-router-dom imports into a single line
import { Link, Outlet, useLocation, useParams } from "react-router-dom";

import { IoAddCircleOutline } from "react-icons/io5";
import { Layout } from "../components/section";
import { PageHeader } from "../components/header";

export const Services = () => {
  const location = useLocation();
  const params = useParams();

  // 2. Extract complex routing logic into a cleanly named boolean variable
  const isCreatePage = location.pathname.includes("create");
  const isEditPage = Boolean(params.slug);
  const showAddButton = !isCreatePage && !isEditPage;

  return (
    <>
      <PageHeader title="Services">
        {showAddButton && (
          <Link
            to="/services/create"
            title="Create New Service"
            aria-label="Create New Service"
          >
            <IoAddCircleOutline />
          </Link>
        )}
      </PageHeader>

      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};
